export default __webpack_public_path__ + "static/media/2057.d3575de5.png";